import './header.scss';
import clsx from 'clsx';
import { NavLink, Link, useNavigate, useLocation } from 'react-router';
import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { useTgStore } from '@/stores/tg';
import { useUserStore } from '@/stores/user';

interface HeaderProps {
  withBorder: boolean; // will show border-bottom with shadow
  hideAuth?: boolean;
}

function Header({ withBorder = false, hideAuth = false }: HeaderProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useUserStore((s) => s.isAuthenticated);
  const authName = useUserStore((s) => s.authName);
  const avatarUrl = useUserStore((s) => s.avatarUrl);
  const logout = useUserStore((s) => s.logout);

  const isTgAIPage = typeof window !== 'undefined' && location.pathname.startsWith('/ai/answers/');
  const isLandingPage = typeof window !== 'undefined' && location.pathname === '/landing';
  const shouldHideAuth = hideAuth || isLandingPage;

  const [theme, setTheme] = useState<'light' | 'dark'>('light');
  const { tgTheme } = useTgStore();

  useEffect(() => {
    if (isTgAIPage) {
      setTheme(tgTheme);
    }
  }, [tgTheme]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className={clsx('header', withBorder && 'header_border-bottom', theme)}>
      <div className="header__content">
        <div className="header__left">
          <h3 className={clsx('header__main-logo', theme)}>
            <img className="header__main-logo-img" src="/logo.png" alt="logo" />
            {shouldHideAuth ? (
              <a href="/">Repeteka</a>
            ) : (
              <NavLink to={!isTgAIPage ? '/' : '#'}>Repeteka</NavLink>
            )}
          </h3>
          <div className={clsx('header__links', theme)}>
            <NavLink
              className={clsx('header__link', theme)}
              to={'https://t.me/repeteka_bot'}
              target="_blank"
              rel="noreferrer"
            >
              <img src="/meeting_icons/tg_bot.svg" />
              <span className={clsx('header__link-text', theme)}>Repeteka bot</span>
            </NavLink>
          </div>
        </div>
        {!isTgAIPage && (
          <div className="header__right">
            {isAuthenticated ? (
              <div className="header__profile">
                <Link to="/profile" className="header__profile-link">
                  <Avatar
                    image={avatarUrl || undefined}
                    label={(authName || '?').charAt(0).toUpperCase()}
                    shape="circle"
                  />
                  <span className="header__profile-name">{authName}</span>
                </Link>
                <Button
                  className="header__auth-button"
                  label="Выход"
                  icon="pi pi-sign-out"
                  size="small"
                  onClick={handleLogout}
                />
              </div>
            ) : (
              !shouldHideAuth && (
                <div className="header__auth">
                  <Link to="/login">
                    <Button
                      className="header__auth-button header__auth-button_login"
                      link
                      size="small"
                    >
                      <span className="text">Вход</span>
                      <i className="pi pi-sign-in icon"></i>
                    </Button>
                  </Link>
                  <Link to="/register">
                    <Button className="header__auth-button" size="small">
                      <span className="text">Регистрация</span>
                      <i className="pi pi-user-plus icon"></i>
                    </Button>
                  </Link>
                </div>
              )
            )}
          </div>
        )}
      </div>
    </nav>
  );
}

export default Header;
